import styled from 'styled-components';

import {
  NewDatePickerField as BaseDatePickerField,
  NewNumberInputField as BaseNumberInputField,
  NewSelectField as BaseSelectField,
  NewTimePickerField as BaseTimePickerField,
} from '@edna/components';
import {mixins} from '@edna/components/styles';

import {SecondaryText} from 'src/components/primitives';

export const SelectField = styled(BaseSelectField)`
  max-width: 400px;
  margin: 0;
`;

export const NumberInputField = styled(BaseNumberInputField)`
  max-width: 180px;
  margin: 0;
`;

export const TimePickerField = styled(BaseTimePickerField)`
  max-width: 94px;
  margin-bottom: 0;
`;

export const DatePickerField = styled(BaseDatePickerField)`
  max-width: 180px;
  margin-bottom: 0;
`;

export const Icon = styled.div`
  ${mixins.wh('24px')}
  margin-right: ${({theme}) => theme.spacing.s1};
`;

export const Buttons = styled.div`
  ${mixins.stack({direction: 'ROW', size: '5'})};
  padding-bottom: ${({theme}) => theme.spacing.s5};
`;

export const TariffLabel = styled(SecondaryText)`
  overflow-wrap: break-word;
`;
